import doubleAc from "../data/images/double_ac.jpeg";
import suitAc from "../data/images/suite_ac.jpeg";
import tripleAc from "../data/images/triple_ac.jpeg";

export const rooms = [
  {
    id: 1,
    name: "Classic Double",
    description:
      "Thoughtfully designed with refined interiors, offering comfort and quiet elegance.",
    image: doubleAc,
    variants: [
      {
        type: "AC",
        price: 2299,
      },
      {
        type: "Non-AC",
        price: 1899,
      },
    ],
  },
  {
    id: 2,
    name: "Classic Triple",
    description:
      "Spacious interiors with enhanced amenities for a truly elevated stay experience.",
    image: tripleAc,
    variants: [
      {
        type: "AC",
        price: 2699,
      },
      {
        type: "Non-AC",
        price: 2299,
      },
    ],
  },
  {
    id: 3,
    name: "Suite",
    description:
      "An exclusive space where luxury, privacy, and timeless design come together.",
    image: suitAc,
    variants: [
      {
        type: "AC",
        price: 2699,
      },
      {
        type: "Non-AC",
        price: 2299,
      },
    ],
  },
];